
import { useState } from "react";

export const useOTPInput = () => {
  const [otp, setOtp] = useState("");
  const [resendCooldown, setResendCooldown] = useState(0);

  const handleOTPChange = (value: string) => {
    setOtp(value);
  };

  const startResendCooldown = () => {
    setResendCooldown(60);
  };

  const resetOTP = () => {
    setOtp("");
  };

  return {
    otp,
    resendCooldown,
    handleOTPChange,
    startResendCooldown,
    setResendCooldown,
    resetOTP,
  };
};
